import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { IconComponent } from './icon.component';
@NgModule({
  declarations: [IconComponent],
  imports: [CommonModule, MatIconModule, HttpClientModule],
  exports: [IconComponent],
})
export class IconModule {}
